import { useState, useEffect, useMemo } from "react"
import { useStores } from "stores/root-store"
import { storageName } from "shared/constants/storage-constant"
import UploadDialog from "components/common/upload/upload-dialog"
import template from "assets/templates/eStore Item Master Template v2.zip"
import { columnsUpload, filterData, columns, hiddenColumns, columnsExtraInventory, columnsUploadFunctionsMap, exportColumnsExtra } from "./constants"
import { rootStore } from "stores/root-store"
import InventoryForm from "components/inventory/dialog/inventory-form"
import { observer } from "mobx-react-lite"
import CommonPage from "components/common/common-page"
import { useNavigate, useSearchParams } from "react-router-dom"
import { getModuleName } from "utils/app-helper"
import * as StorageHelper from "utils/storage-helper"
import { parsePresetFilters } from "utils/preset-filters"

// Multi-select filters a link into this page (e.g. a home dashboard tile) can
// pre-set via the query string; each accepts a comma-separated list of values.
const PRESET_MULTI_FILTERS = ["item_category1", "item_category2", "item_category3"]

const Products = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const [openUpload, setOpenUpload] = useState(false)
  const [columnsExtra, setColumnsExtra] = useState([])

  const { InventoryStore } = useStores()

  const moduleName = getModuleName(storageName.inventoryFilter)

  const presetFilters = useMemo(() => parsePresetFilters(searchParams, PRESET_MULTI_FILTERS), [searchParams])

  useEffect(() => {
    rootStore.setOpenForm(false)
    rootStore.setScreenTitle("Products Search")
    InventoryStore.resetData()

    const importingModule = StorageHelper.getStorage(storageName.importingModule)
    if (importingModule === moduleName) setOpenUpload(true)

    return () => rootStore.setScreenTitle("")
  }, [])

  const refreshDataIfNeeded = () => {
    if (InventoryStore.searchText) InventoryStore.loadData()
  }

  const handleClickOpen = () => {
    rootStore.setScreenTitle("")
    rootStore.setOpenForm(true)
  }

  const handleClickOpenUpload = () => {
    setOpenUpload(true)
  }

  const handleUploadClose = () => {
    setOpenUpload(false)
    refreshDataIfNeeded()
  }

  const handleClose = () => {
    InventoryStore.setSelectedId("")
    rootStore.setScreenTitle("Products Search")
    rootStore.setOpenForm(false)
  }

  const handleSave = () => {
    handleClose()
    refreshDataIfNeeded()
  }

  const handleRowClicked = params => {
    navigate(`/products/${encodeURIComponent(params.row["PRODUCT"])}`)
  }

  if (rootStore.openForm) return <InventoryForm onSave={handleSave} onClose={handleClose} />

  const handleFilterItemValueChanged = (val, key) => {
    setColumnsExtra(key == "including_inventory" && val ? columnsExtraInventory : [])
  }

  return (
    <>
      <CommonPage
        DataStore={InventoryStore}
        filterData={filterData}
        presetFilters={presetFilters}
        searchPlaceholder={"Search for Product code, Description or Cross reference."}
        filterStorageName={storageName.inventoryFilter}
        allowArchivalSearch={false}
        columns={columns}
        hiddenColumns={hiddenColumns}
        gridStorageName={storageName.inventoryColumn}
        searchRequiredWarningMsg="Search for a specific product and select a filter to narrow down your search"
        noDataMsg="Your search returned no results. Please contact ops@estorelogistics.com.au if you believe this error is incorrect."
        exportFileName="Express_Inventory"
        idProp={"id"}
        columnsExtra={columnsExtra}
        exportColumnsExtra={exportColumnsExtra}
        handleAddClicked={handleClickOpen}
        handleUploadClicked={handleClickOpenUpload}
        handleRowClicked={handleRowClicked}
        onFilterItemValueChanged={handleFilterItemValueChanged}
      />

      <UploadDialog
        title={"Inventory"}
        moduleName={moduleName}
        startFrom={6}
        columns={columnsUpload}
        columnsUploadFunctionsMap={columnsUploadFunctionsMap}
        idColumn={"PRODUCT"}
        DataStore={InventoryStore}
        downloadLink={template}
        open={openUpload}
        onClose={handleUploadClose}
      />
    </>
  )
}

export default observer(Products)
